import { useQuery } from '@tanstack/react-query';
import getAchievementRank from 'Api/host-achievement-detail/getAchievementRank';
import getAchievementRankRequest from 'Domain/host-achievement-detail/model/request/getAchievementRankRequest';
import getAchievementRankResponse from 'Domain/host-achievement-detail/model/response/getAchievementRankResponse';

const useGetAchievementRank = (queryParams) => {
  return useQuery({
    queryKey: ['achievement-rank', queryParams],
    queryFn: async () => {
      const queries = getAchievementRankRequest(queryParams);

      const response = await getAchievementRank(queries);

      const result = getAchievementRankResponse(response, queryParams?.metric);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetAchievementRank;
